import React, {useState, useEffect, useRef} from 'react'
import _ from 'lodash';
import cx from 'classnames';

import { BackgroundView } from '../../background';

import styles from './card.module.scss';
const CarouselCardWidgetComponent =({ className, style, widgetProps, breakpoint, children, parentStyle, stretched,  ...rest })=> {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const [windowWidth, setWindowWidth] = useState(null);
  const background = _.get(widgetProps, 'properties.desktop.background');
  const layout = _.get(widgetProps, 'properties.desktop.layout');

  useEffect(() => {
    if(!windowWidth) {
      handleResize()
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const widgetStyle = {
    ...style,
    height: _.get(parentStyle, 'height'),
    width : stretched  ? `${windowWidth}px` : _.get(parentStyle, 'width'),
    transform: 'none',
  }

  return (
    <div id={id}
      className={cx(className, styles.carouselCard)}
      style={widgetStyle}
      data-widget-id={id}
      data-widget-type={type}
    >
      <BackgroundView background={background} breakpoint={breakpoint} />
      <div className={styles.inner}>
        {children}
      </div>
    </div>
  );
}

const carouselCardWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const CarouselCardWidget = React.memo(CarouselCardWidgetComponent, carouselCardWidgetEquals);
